module.exports = __webpack_public_path__ + "static/img/icon-postage.661198b7.png";